(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  if (!window.__faqRevealInit) {
    window.__faqRevealInit = true;

    const faqObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            faqObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );

    const revealFaqRows = () => {
      document
        .querySelectorAll('.product-faq .accordion accordion-custom:not(.is-revealed)')
        .forEach((el, i) => {
          el.style.transitionDelay = Math.min(i * 0.06, 0.4) + 's';
          faqObserver.observe(el);
        });
    };

    revealFaqRows();
    document.addEventListener('shopify:section:load', revealFaqRows);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature-cards"] && !Shopify.designMode) return;
  try {
    
  if (!window.__scrollRevealInit) {
    window.__scrollRevealInit = true;

    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    document.querySelectorAll('[data-scroll-reveal]').forEach((el) => revealObserver.observe(el));

    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)').forEach((el) => revealObserver.observe(el));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-lifestyle"] && !Shopify.designMode) return;
  try {
    
    if (!window.__scrollRevealInit) {
      window.__scrollRevealInit = true;

      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );

      document.querySelectorAll('[data-scroll-reveal]').forEach((el) => revealObserver.observe(el));

      document.addEventListener('shopify:section:load', () => {
        document.querySelectorAll('[data-scroll-reveal]:not(.is-revealed)').forEach((el) => revealObserver.observe(el));
      });
    }
  
  } catch(e) { console.error(e); }
})();
})();
